export default {
    id: null,
    adv_type: 'Купівля',
    category: null,
    type: null,
    repair: null,
    price: null,
    rooms: null,
    walls: null,
    floor: null,
    city_id: null,
    districts: null,
    street: null,
    comment: null,
    house_number: null,
    apartment_number: null,
    stage_id: null,
    client_id: null,
    closed_at: null,
}
